/* globals google */
(function() {

  'use strict';

  function ResumoPedidoCtrl(
    $scope,
    $state,
    $timeout,
    $location,
    $interval,
    $window,
    $uibModal,
    Pedido,
    Cliente,
    Auth,
    localStorageService,
    Pagamento,
    Cep,
    URL,
    Perfil,
    moment
  ) {

    var vm = this;

    vm.loadPagamento = true;
    vm.textoLoadPagamento = 'Carregando...';

    vm.foraArea = false;
    vm.popover = {
      isOpen: false,
      templateUrl: 'trialModal.html',
    };

    Perfil.getUserData()
      .then(function (user) {
        vm.user = user;
        vm.isTrial = user.modoDemonstracao;
      })
      .catch(function (err) {
        console.log(err);
      });

    var map, geocoder, image, enderecoMapa, iconeMapa, address, mapOptions;

    $window.initMap = function() {
      enderecoMapa = vm.resumo.endereco.logradouro + ', ' + vm.resumo.endereco.numero + ' - ' + vm.resumo.endereco.bairro + ' ' + vm.resumo.endereco.cidade + ' - ' + vm.resumo.endereco.uf + ' ' + vm.resumo.endereco.cep;

      iconeMapa = URL + (vm.resumo.diaAdicional == 0 ? '/assets/images/icone_mapa_area_de_coleta.png' : vm.resumo.diaAdicional == 1 ? '/assets/images/icone_mapa_D1.png' : '/assets/images/icone_mapa_fora_da_area.png');

      address = enderecoMapa;

      image = iconeMapa;

      mapOptions = {
        zoom: 17,
        icon: image
      };

      geocoder = new google.maps.Geocoder();

      geocoder.geocode({ 'address': address }, function(results, status) {
        map = new google.maps.Map(document.getElementById('map'), mapOptions);
        if (status == google.maps.GeocoderStatus.OK) {
          map.setCenter(results[0].geometry.location);
          var marker = new google.maps.Marker({
            map: map,
            icon: image,
            position: results[0].geometry.location
          });
        } else {
          console.log('Geocode was not successful for the following reason: ' + status);
          var mapContainerc = document.getElementById('map');
          mapContainerc.style.display = 'none';
        }
      });

    };

    function loadData() {
      Pagamento.busca().then(function(cartao) {
        // cartao habilitado
        // cartao desabilitado
        if ((cartao.formaPagamento !== null) && (cartao.formaPagamento.dataHoraUsarComoPadrao !== null)) {
          vm.showCartao = true;
          vm.showBoleto = false;
          vm.cartaoCliente = cartao.formaPagamento.bandeira + ' terminado em ' + cartao.formaPagamento.ultimosNumeros;
        } else {
          vm.showCartao = false;
          vm.showBoleto = true;
        }
        vm.loadPagamento = false;
        vm.textoLoadPagamento = 'Finalizar pedido';
      }).catch(function(error) {
        $scope.tratarErrosBackEnd(error);
      });

      var pedido;
      Pedido.getPedidoAsync().then(function(order) {
        pedido = angular.copy(order);

        Pedido.obterDadosCheckout(pedido.id)
          .then(function(checkout) {
            vm.resumo = checkout;
            vm.temDiaAdicional = vm.resumo.diaAdicional > 0;
            vm.foraArea = vm.resumo.diaAdicional === null;

            $window.initMap();

            vm.resumo.cliente = pedido.cliente;

            verificarCupom(pedido);
            $timeout(function () {
              vm.popover.isOpen = true;
            }, 100);
          });
      });
    }

    $scope.timer = $interval(function() { loadData(); }, 30 * 60 * 1000);

    // destroi timer de atualizacao do mapa
    $scope.$on('$destroy', function() {
      if ($scope.timer) {
        $interval.cancel($scope.timer);
      }
    });

    loadData();

    function verificarCupom(pedido) {
      var codCupom = localStorageService.get('codigoCupom') ? localStorageService.get('codigoCupom') : $location.search().cupom;

      // Se não veio da tela de pagamento e existe cupom
      // no LS ou na URL, chama back para obter mensagem cupom.
      // Senão, carrega somente os dados disponíveis.
      if (!pedido.cliente.codigoCupom && codCupom) {
        var clienteAtual = pedido.cliente;

        var cpf = null;
        var cnpj = null;
        if (clienteAtual.cpf) {
          cpf = clienteAtual.cpf;
        } else {
          cnpj = clienteAtual.cnpj;
        }

        var clienteAtual = {
          id: Auth.getCurrentUser().id,
          cpf: cpf,
          cnpj: cnpj,
          codigoCupom: codCupom
        };

        Cliente.atualizar(clienteAtual)
          .then(function(clienteAtualizado) {
            vm.resumo.cliente = clienteAtualizado;
          })
          .catch($scope.tratarErrosBackEnd);
      }
    }

    vm.finalizarPedido = function() {
      var pedidoAtualizado = {
        situacao: 'RetiradaAgendada',
        codigoPromocao: Pedido.getPedido().cliente.codigoCupom
      };
      Pedido.atualizar(Pedido.getPedido().id, pedidoAtualizado)
        .then(function(pedido) {
          // Limpa o cupom do local storage
          localStorageService.remove('codigoCupom');

          // atualiza o pedido com retorno do back-end
          Pedido.setPedido(pedido);

          // vai para a tela de acompanhamento
          $state.go('pedido-detalhe', {
            'idPedido': pedido.id,
            'acabouDeFinalizar': true
          });
        })
        .catch($scope.tratarErrosBackEnd);
    };

    vm.closePopover = function () {
      vm.popover.isOpen = false;
    };

    vm.showTestModal = function () {
      $uibModal.open({
        windowClass: 'trial-modal',
        template: require('../../modal/modal-trial-mode.html'),
        controllerAs: '$ctrl',
        backdrop: 'static',
        keyboard: false,
        controller: ['$uibModalInstance', function ($uibModalInstance) {
          var $ctrl = this;
          $ctrl.close = function () {
            $uibModalInstance.close();
          };
        }],
      })
      .result
      .then(function () {
        $state.go('pedido.encomendas');
      });
    };

    $scope.tratarErrosBackEnd = function(err) {
      $scope.errors = {};
      if (err && err.erro) {
        $scope.addAlert(err.erro);
      } else if (err && err.message) {
        $scope.addAlert(err.message);
      } else if (err.data && err.data.erro) {
        $scope.addAlert(err.data.erro);
      } else if (err.data && err.data.length) {
        for (var erro in err.data) {
          $scope.$emit('erroEncontrado', err.data[erro].message);
        }
      }
    };

  }

  angular
    .module('mandaeApp')
    .controller('ResumoPedidoCtrl', ResumoPedidoCtrl);
})();
